// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"SectionHeader_sectionHeader__KdE5l","sectionHeader__title":"SectionHeader_sectionHeader__title__N8Jrz"};